export default __webpack_public_path__ + "static/media/unavailable_s.3072095a.png";